import React, { FC } from 'react'
import { Container, TitleComponent, Subtitle } from './styled-components'
import Page from '../page'

type TProps = {
  title: string,
  subtitle: string
}

const CoverPage: FC<TProps> = ({
  title,
  subtitle
}) => {
  return <Page>
    <Container>
      <TitleComponent>{title}</TitleComponent>
      <Subtitle>{subtitle}</Subtitle>
    </Container>
  </Page>
}

export default CoverPage